/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Fetch_UserInputs */



/**
* | output |
* | --- |
* | "Couldn't load your account. Please try again." |
*
* @param {Auth_Error_Fetch_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_fetch_user = /** @type {((inputs?: Auth_Error_Fetch_UserInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Fetch_UserInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger votre compte. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar su cuenta. Por favor, intente de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar sua conta. Por favor, tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare il tuo account. Riprova.")
	return /** @type {LocalizedString} */ ("Couldn't load your account. Please try again.")
});